import { Application } from "@/api";

const applications: Application[] = [
    {
        "id": "8a48810e9c4d5332019c4e28e62f7a1d",
        "name": "Telcom Demo (Okta)",
        "description": "Snowflake datasource name - TLX_TELCO",
        "createdDate": new Date("2026-02-11T19:23:49.172+0000"),
        "lastModifiedDate": new Date("2026-02-26T09:00:04.778+0000"),
        "createdBy": "acmeadmindev@gmail.com",
        "lastModifiedBy": "acmeadmindev@gmail.com",
        "deleted": false,
        "status": "ACTIVE",
        "type": "AI_AGENT",
        "configParameters": "{\"entitlementSource\":\"8a48826099341fbe01993608df2b01fd\"}"
    },
    {
        "id": "8a4882619a6eef6b019a72c697366a58",
        "name": "HealthCare Agent (Entra Identity)",
        "description": "Azure AD",
        "createdDate": new Date("2025-11-11T11:56:48.834+0000"),
        "lastModifiedDate": new Date("2026-01-10T20:35:11.640+0000"),
        "createdBy": "acmeadmindev@gmail.com",
        "lastModifiedBy": "acmeadmindev@gmail.com",
        "deleted": false,
        "status": "ACTIVE",
        "type": "AI_AGENT",
        "configParameters": "{\"entitlementSource\":\"8a48825a99a88ec80199a8e5349600e4\",\"clientId\":\"1229ad5b-c1de-4bc6-88db-f0275447c2b4\"}"
    },
    {
        "id": "8a48827e9b9deea0019b9fcffbee2ed4",
        "name": "Health Care Agent (Okta Identity)",
        "description": "Okta",
        "createdDate": new Date("2026-01-08T22:52:46.447+0000"),
        "lastModifiedDate": new Date("2026-01-10T20:34:49.110+0000"),
        "createdBy": "acmeadmindev@gmail.com",
        "lastModifiedBy": "acmeadmindev@gmail.com",
        "deleted": false,
        "status": "ACTIVE",
        "type": "AI_AGENT",
        "configParameters": "{\"entitlementSource\":\"8a4881e094f48aed0194f9dcc1616c3a\",\"clientId\":\"0oayweh11qktfctzj697\"}"
    }
]

export default applications;